function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var customStyleContent = `/* ====================================================== */
/* ====================================================== */
/* ====================================================== */
/* THE STRUCTURED CSS SELECTORS INSTEAD OF ORIGINAL ONES */
/* ====================================================== */
/* ================== LANDING & CATNAV ================== */
/* ====================================================== */
/* ====================================================== */

/* VARIABLES */
.klevuLanding {
    --klv-filter-width: 25%;
    margin: 0 auto 100px;
}

/* NORMALIZE CSS */
[ku-container] a,
[ku-container] p,
[ku-container] div,
[ku-container] ul li {
    font-family: inherit;
    font-size: 14px;
    line-height: 1;
    text-decoration: none;
    font-weight: normal;
}

.klevuLanding.kuSearchResultsPageContainer .kuClearBoth,
.klevuLanding.kuSearchResultsPageContainer [data-container-role="content"]:after {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    content: none !important;
}

/* MAIN CONTAINER-WRAPPER*/
.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] {
    margin: 0 auto;
    max-width: none;
    width: auto;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer {
    padding: 40px 30px;
    max-width: 100%;
}

.klevuLanding.kuSearchResultsPageContainer .kuContainer .kuTabs {
    text-align: left;
    margin-bottom: 0;
    margin-top: 15px;
    border-bottom: unset;
    grid-area: tabs;
}

.klevuLanding.kuSearchResultsPageContainer .kuContainer .kuTabs a {
    font-size: 12px;
    font-weight: 700;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList {}

/* Grid view */
/* For some reason the 1st time it loads in Incognito mode with [data-result-view=productList] */
/* And the all times after this it loads with [data-result-view=grid] */
/* Default - Grid View */
.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList.klevuMeta[data-result-view="productList"],
.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList.klevuMeta[data-result-view="grid"] {}

/* List View */
.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList.klevuMeta[data-result-view="list"] {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList .kuResultContent {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList .kuResultContent .kuResultWrap {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="main"] .kuContainer .kuResultsListing .productList .kuResultContent .kuResultWrap.kuBlockFullwidth {}

/* FILTERS */
.klevuLanding.kuSearchResultsPageContainer .kuFilters[data-position="top"] {
    display: none;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-ratings-wrapper {
    font-family: 'JudgemeStar' !important;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-brand-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .jdgm-prev-badge__text {
    display: none;
}

/* 
[data-container-role="left"] .kuFilters {
    padding: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFiltersTitleHeading {
    color: #414042 !important;
    display: block;
    border: 0 solid #414042;
    font-size: 16px;
    height: 32px;
    line-height: 20px;
    padding: 0;
    width: unset;
    text-align: left;
    min-width: 140px;
    margin-bottom: 20px;
}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter {
    border: 1px solid #e8e8e8;
    display: inline-block;
    height: auto;
    margin-bottom: 0;
    margin-left: -1px;
    min-width: 90px;
    position: relative;
    width: auto;
}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterHead {
    border-bottom: 0 none;
    border-right: 0 solid #e8e8e8;
    color: #414042;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    margin: 0;
    font-size: 13px;
}

.klevuLanding.kuSearchResultsPageContainer .kuFilters[data-position="top"] .kuFilterBox .kuFilterHead::after,
.klevuLanding.kuSearchResultsPageContainer .kuFilters[data-position="top"] .kuFilterBox .kuFilterHead.kuExpand::after {
    border-left: 1px solid #414042;
    border-top: 1px solid #414042;
    content: "";
    display: inline-block;
    height: 2px;
    margin-left: 8px;
    transform: rotate(225deg);
    width: 2px;
    margin-bottom: 2px;
    padding: 4px;
    transition: unset;
    position: initial;
    border-width: 1px 0 0 1px;
} */

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse {}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuExpand {}

.klevuLanding.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer {
    grid-area: tags;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 0;
    margin-top: 10px;
    margin-bottom: 25px;
    width: 87%;
}

.klevuLanding.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagClearAll {
    padding: 5px;
    margin: 0;
    margin-left: 0;
    border: 0;
    color: rgba(68, 89, 88, 0.85);
    font-size: 12px;
    text-transform: lowercase;
    font-weight: 800;
}

.klevuLanding.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagValue {
    margin: 2px;
    display: inline-block;
    cursor: pointer;
    background: #eee;
    border: 0 solid #f8f8f8;
    margin-right: 4px;
    border-radius: 3px;
    letter-spacing: 0;
    font-size: 13px;
    padding: 3px 7px 3px 12px;
    color: #222;
    margin-bottom: 4px;
    display: inline-block;
    line-height: 20px;
}

.kuFilterBox .kuFilterNames {
    height: 122px;
    overflow: hidden;
}


.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul {}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li {}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption {}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterIcon {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kufacet-text {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterTotal {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames .kuShowOpt {}

/* price facet */
.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter[data-filter="klevu_price"] {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter[data-filter="klevu_price"] .kuPriceSlider {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter[data-filter="klevu_price"] .kuPriceSlider .noUi-target {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter[data-filter="klevu_price"] .kuPriceSlider .noUi-handle {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="left"] .kuFilters .kuFilterBox.klevuFilter[data-filter="klevu_price"] .kuPriceSlider .noUi-tooltip {}

/* MAIN RESULT CONTAINER */
.klevuLanding.kuSearchResultsPageContainer [data-container-role="content"] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 15px;
}

/* RESULT CONTAINER */
.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] {
    display: block;
    width: 100%;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] .kuResults {}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-row-gap: 0px;
    grid-template-areas:
        "filters filters filters filters filters"
        "tags tags tags tags tags"
        "tabs tabs tabs tabs tabs"
        "sortBy itemsPerPage viewToggler viewToggler viewToggler";
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] .kuResultsHeadingTitleContainer {
    grid-area: filters;
    padding: 0;
    margin: 20px 0;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] .kuDropSortBy {
    grid-area: sortBy;
    margin: 0;
    white-space: nowrap;
    z-index: 1;
    font-size: 12px;
    color: #414042;
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 12px 0;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel {
    padding: 3px 7px;
    display: inline-block;
    text-transform: capitalize;
    cursor: pointer;
    border: 1px solid #414042;
    padding-right: 35px;
    position: relative;
    min-height: 22px;
    width: auto;
    margin-left: 5px;
    min-width: 135px;
    max-width: 135px;
    font-size: 12px;
    border-radius: 2px;
    color: #414042;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel:after {
    padding: 2.5px;
    position: absolute;
    right: 6px;
    top: 6px;
    color: #414042;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions {
    background-color: #fff;
    min-width: 120px;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    z-index: 12;
    top: 34px;
    right: 0px;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption {
    font-size: 12px;
    padding: 8px;
    color: #414042;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] .kuDropItemsPerpage {
    grid-area: itemsPerPage;
    margin: 0 0 0 10px;
    white-space: nowrap;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] .kuLandingResultsViewSwitchContainer {
    grid-area: viewToggler;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 0;
    margin-left: auto;
}

.klevuLanding.kuSearchResultsPageContainer [data-container-role="center"] [data-block-id="ku_landing_result_header"] .kuPagination {
    grid-area: pagination;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    padding: 0;
}

/* RESULT LIST */
.klevuLanding.kuSearchResultsPageContainer .kuResults {}

.klevuLanding.kuSearchResultsPageContainer [data-result-view="grid"] .kuResults ul,
.klevuLanding.kuSearchResultsPageContainer [data-result-view="productList"] .kuResults ul {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    -webkit-box-pack: stretch;
        -ms-flex-pack: stretch;
            justify-content: stretch;
    gap: 1em;
    width: 100%;
    margin-top: 20px !important;
}

/* PRODUCT ITEM */
.klevuLanding.kuSearchResultsPageContainer [data-result-view="grid"] .kuResults ul li,
.klevuLanding.kuSearchResultsPageContainer [data-result-view="productList"] .kuResults ul li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    margin: 0;
    padding: 10px;
    position: relative;
    float: none;
    gap: 10px;
    outline: 1px solid transparent;
}

.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches button.kcResultItemNavigationButton {
    background: transparent;
    border: 0;
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg);
    width: 60px;
    height: 40px;
}

.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches button.kcResultItemNavigationButton svg {
    fill: #636363;
}

.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches button[disabled] {
    display: none;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .klevu-superior-swatches {
    display: none;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 5px;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover {
    border-left: 0px;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover .klevu-superior-swatches {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    left: -62px;
    border: 1px solid #e3e3e3;
    border-right: 0px;
    height: calc(100% + 2px);
    top: -1px;
    background-color: #fff;
    z-index: 3;
}

.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch {
    height: 60px;
    width: 60px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    border: 1px solid transparent;
    margin: 0 5px;
}

.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch:hover,
.klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch.selected {
    border: 1px solid #e8e8e8;
}


.klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover {
    outline: 1px solid #e8e8e8;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover .kuProdAdditional {
    visibility: visible;
    opacity: 1;
    -webkit-box-shadow: none;
            box-shadow: none;
}

/* Product Image */
.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap {
    border: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .klevu-badge {
    background-color: var(--color-bc-red);
    position: absolute;
    right: 0;
    color: #fff;
    font-weight: 700 !important;
    padding: 5px;
    font-size: 12px !important;
    z-index: 0;
    margin-left: auto;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main {
    margin-bottom: 10px;
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop {
    padding: 0;
    height: 100%;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap {
    height: 100% !important;
    margin-bottom: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap>a {
    position: relative;
    height: auto !important;
    display: block;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap>a::before {
    content: "";
    display: block;
    padding-bottom: 100%;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap>a>img {
    width: auto !important;
    height: auto !important;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100% !important;
    max-height: 200px !important;
    -webkit-transform: translateY(-50%) translateX(-50%);
            transform: translateY(-50%) translateX(-50%);
}

/* Product Footer */
.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer {
    /* flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column; */
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom {
    height: 100% !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    padding: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-brand {
    font-size: 15px;
    text-decoration: none;
    font-weight: 300;
    color: #414042;
    border: 0;
    word-break: break-word;
    line-height: 24px;
    font-weight: 700;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover .kuProdWrap footer .kuProdBottom .klevu-sizes {
    visibility: visible;
    opacity: 1;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-sizes {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: #636363;
    gap: 5px;
    font-size: 11px;
    padding: 10px 0;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    visibility: hidden;
    opacity: 0;
    margin-top: 20px;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-sizes div {
    font-size: 12px;
    color: #636363;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName {
    display: block !important;
    margin-bottom: 15px;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick {
    font-size: 15px;
    text-decoration: none;
    font-weight: 300;
    color: #414042;
    border: 0;
    word-break: break-word;
    line-height: 1.3;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick:hover {
    text-decoration: none;
}

.klevuNoResultsRecs-itemPrice .klevuQuickPriceGreyText,
.productQuick-Price .klevuQuickPriceGreyText,
.kuPrice .klevuQuickPriceGreyText {
    color: var(--color-bc-red) !important;
    font-size: 12px !important;
    line-height: 18px;
    font-weight: 700 !important;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice {
    margin-top: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 7px;
    line-height: normal;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice {
    font-size: 16px;
    font-weight: bold;
    font-family: inherit;
    text-align: right;
    display: inline;
    margin-right: 0;
}
.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice.red {
    color: var(--color-bc-red);
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuOrigPrice {
    font-size: 15px;
    text-decoration: line-through;
    color: #636363;
    text-align: right;
    display: inline;
    margin-right: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice>span {}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional {
    display: none;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData {
    visibility: visible;
    opacity: 1;
    -webkit-box-shadow: none;
            box-shadow: none;
    position: unset;
    padding: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuSwatches {

    display: none;
}


.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart {
    margin: 0;
}

.klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart>a {
    margin: 0;
    padding: 0;
    width: 100%;
    border: 0;
    line-height: 40px;
    height: 40px;
}


/* NO RESULTS */
.klevuLanding .kuLandingNoRecordFound {
    margin: 0;
}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults {
    max-width: none;
    margin: 0;
    background-color: transparent;
}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuLandingNoResultsInner {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResultsMessage {
    padding: 0;
    margin: 0;
}

.klevuLanding .kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider {}

.klevuLanding .kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider .klevuNoResultsRecs {}

.klevuLanding .kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider .klevuNoResultsRecs>h3 {
    margin: 0;
}

.klevuLanding .kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider .klevuNoResultsRecsWrap {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecsWrap .klevuNoResultsRecsResults {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecsWrap .klevuNoResultsRecsResults {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecsWrap .klevuNoResultsRecsResults .klevuNoResultsRecsResultsInner {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap {
    margin: 0;
    -webkit-box-flex: 25%;
        -ms-flex: 25%;
            flex: 25%;
}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-item {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-item .klevuNoResultsRecs-itemImg {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-item .klevuNoResultsRecsImg {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-item .klevuNoResultsRecsImg>img {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc .klevuNoResultsRecsTitle {}

.klevuLanding .kuLandingNoRecordFound .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc .klevuNoResultsRecs-itemPrice {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchesBlock {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchTerms {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchTerms .klevuHeadingText {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchTerms>ul {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchTerms>ul li.kuNoResultsLandingPopularSearchTerm {}

.klevuLanding .kuLandingNoRecordFound .kuLandingNoResults .kuNoResultsLandingPopularSearchTerms>ul li.kuNoResultsLandingPopularSearchTerm>a {}

/* END OF NO RESULTS */

.kuSearchResultsPageContainer .kuResultsHeadingTitleContainer {
    display: none;
}

/* END OF THE STRUCTURED CSS SELECTORS INSTEAD OF ORIGINAL ONES */

.klevuLanding.kuSearchResultsPageContainer [data-container-role=center] {
    z-index: 0;
}

.klevuResultsBlock .klevuQuickSearchResults ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
}

button.wk-button.wk-button--add {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0;
    z-index: 3;
}

.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop,
.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom {
    float: none;
}

.kuSearchResultsPageContainer .kuShowOpt {
    display: none !important;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse+.kuFilterNames:not(.sliderFilterNames) {
    height: auto;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames) {
    overflow: auto;
    max-height: 200px;
}

/* Custom scrollbar styles for WebKit-based browsers */
.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar {
    width: 5px;
    border-radius: 2px;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar-track {
    background-color: #d9d9d9;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar-thumb {
    background-color: #666666;
    border-radius: 2px;
}

.ku-klevu .shopify-block >h1 {
    visibility: hidden;
    display: none;
}

body.ku-klevu h1.klevu-searchresults-title {
    margin-bottom: 60px;
    font-size: 35px;
    font-weight: 700;
    text-transform: uppercase;
    color: #505050;
    line-height: 1.1;
}


h3.kuFiltersTitleHeading {
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: 700;
    line-height: 1.1;
    color: #505050;
}

.ku-klevu .section.section-blends.section-full {
    padding-top: 0;
}
@media screen and (max-width: 990px) {
    .ku-klevu .page-width {
        padding: 0 1.5rem;
    }

    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches button.kcResultItemNavigationButton,
    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .kcResultItemNavigation {
        display: none;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li .klevu-superior-swatches,
    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover .klevu-superior-swatches {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        gap: 5px;
        position: initial;
        margin-bottom: 10px;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li:hover .klevu-superior-swatches {
        border: 0;
    }

    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch {
        height: 35px;
        width: 35px;
        margin: 0;
    }

    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch img {
        display: none;
    }

    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch span {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background-position: center center !important;
        border-radius: 50%;
        background-size: contain !important;
        background-repeat: no-repeat !important;
    }

    .klevuLanding.kuSearchResultsPageContainer .klevu-superior-swatches .variant-swatch:hover {
        border-radius: 50%;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap>a>img {
        max-height: 100% !important;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop .klevuImgWrap>a::before {
        padding-bottom: 60%;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li .klevu-badge {
        bottom: 0;
    }

    .klevuLanding.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-sizes {
        display: none;
    }
}

@media screen and (max-width: 767px) {

    .klevuLanding.kuSearchResultsPageContainer [data-container-role=content] {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .ku-filterOpener {
        width: 98%;
        border: 1px solid #000;
        margin-bottom: 10px;
        background-color: #ececec;
        text-align: center;
        padding: 12px;
    }

    .kuSearchResultsPageContainer .kuFilters {
        height: auto;
    }

    .kuFilters_opened .mobFilterHeader,
    .kuFilters_opened .kuFilters {
        display: block;
    }

    .kuSearchResultsPageContainer .ku-mobFilterWrapper {
        position: initial;
        max-width: 100%;
    }

    .kuFilters_opened .ku-mobFilterWrapper {
        overflow-y: scroll;
        width: 100%;
    }

    .mobFilterHeader {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        border-bottom: 1px solid #ddd;
    }

    .mobFilterHeader span {
        font-size: 27px;
        font-weight: bold;
    }

    .mobFilterHeader,
    .kuFilters,
    .ku-mobFilterWrapper .kuFiltersTitleHeading {
        display: none;
    }

    .ku-klevu section[data-container-id=ku_landing_main_content_left] {
        width: 100% !important;
        display: block;
        max-width: unset;
        margin-top: 10px;
    }

    [data-block-id="ku_landing_left_facets"] {
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .ku-filterOpener span {
        font-size: 14px;
    }

    .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames) {
        overflow: hidden;
        max-height: none;
    }
}`;

var klevu_lang = "de"; 

async function _callJudgemeAPI(productID, URL) {
    const req = new XMLHttpRequest();
    req.open("GET", URL + "?api_token=XM920p3oxqfEEeUGjSF6HYZKpz4&shop_domain=boc24.myshopify.com&external_id=" + productID);
    // req.open("GET", URL + "?api_token=2X2khKjJJqngtmapMPILPxhaFhc&shop_domain=boc24-dev.myshopify.com&external_id=" + productID);
    req.setRequestHeader("accept", "application/json");
    req.send();

    if (req.readyState === XMLHttpRequest.DONE) {
        return req;
    }

    let res;
    const p = new Promise(r => (res = r));
    req.onreadystatechange = () => {
        if (req.readyState === XMLHttpRequest.DONE) {
            res(req);
        }
    };
    return p;
}

klevu({
    theme: {
        setHelpers: {
            "landing, catnav": {
                myCustomSortBy: function(dataLocal) {
                    /* sets the selected option to the display */

                    var selectedText = "";

                    var klevuStorage = klevu.getSetting(klevu.settings, "settings.storage");

                    switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
                        case "RELEVANCE":
                            selectedText = "Relevanz";
                            break;
                        case "PRICE_ASC":
                            selectedText = "Preis niedrig bis hoch";
                            break;
                        case "PRICE_DESC":
                            selectedText = "Preis: hoch bis niedrig";
                            break;
                        case "NAME_ASC":
                            selectedText = "Alphabetisch, A-Z";
                            break;
                        case "NAME_DESC":
                            selectedText = "Alphabetisch, Z-A";
                            break;
                        case "NEW_ARRIVAL_DESC":
                            selectedText = "Datum, Alt zu Neu";
                            break;
                        case "NEW_ARRIVAL_ASC":
                            selectedText = "Datum, Neu zu Alt";
                            break;
                        default:
                            selectedText = "Best Match";
                    }
                    return selectedText;
                },
                // use in JS: scope.kScope.template.getHelpers().isScreenWidthSmaller()
                // use in templates: <% helper.isScreenWidthSmaller() %>
                isScreenWidthSmaller: function (screenWidth) {
                    if (!screenWidth) screenWidth = 990;
                    var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    return widthOfScreen <= screenWidth;
                },
                initSwatchesCarousel: function (data, scope) {
                    var swatchesContainers = document.querySelectorAll(".klevu-superior-swatches");

                    swatchesContainers.forEach(function (container) {
                        var swatchButtons = container.querySelectorAll(".kcResultItemNavigationButton");
                        var variantSwatches = container.querySelectorAll(".variant-swatch");
                        var swatchesToShow = 4;
                        var currentIndex = 0;

                        // Function to show/hide swatches based on current index
                        function toggleSwatches() {
                            for (var i = 0; i < variantSwatches.length; i++) {
                                if (i >= currentIndex && i < currentIndex + swatchesToShow) {
                                    variantSwatches[i].style.display = "flex";
                                } else {
                                    variantSwatches[i].style.display = "none";
                                }
                            }
                            // Disable/enable navigation buttons
                            swatchButtons[0].disabled = currentIndex === 0;
                            swatchButtons[1].disabled = currentIndex + swatchesToShow >= variantSwatches.length;
                        }

                        // Show initial set of swatches
                        toggleSwatches();

                        // Event listener for right button
                        swatchButtons[1].addEventListener("click", function () {
                            if (currentIndex + swatchesToShow < variantSwatches.length) {
                                currentIndex++;
                                toggleSwatches();
                            }
                        });

                        // Event listener for left button
                        swatchButtons[0].addEventListener("click", function () {
                            if (currentIndex > 0) {
                                currentIndex--;
                                toggleSwatches();
                            }
                        });
                    });
                },
                getProductReviewCallback: function (data, entries) {
                    klevu.each(entries, async function(key, item) {
                        if (item.isIntersecting) {
                            // fetch the review
                            const itemGroupId = item.target.dataset.itemGroupId;
                            let judgemeWrapper = document.querySelector(`.klevu-ratings-wrapper .jdgm-widget[data-id="${itemGroupId}"]`);
                            // console.log("itemGroupId", itemGroupId);
                            if (judgemeWrapper && itemGroupId) {
                                // return;
                                if (data.judgeme.observedIds[itemGroupId]) {
                                    judgemeWrapper.innerHTML = data.judgeme.observedIds[itemGroupId];
                                } else {
                                    const response = await _callJudgemeAPI(itemGroupId, "https://judge.me/api/v1/widgets/preview_badge");
                                    const status = response.status;
                                    if (status === 0 || (status >= 200 && status < 400)) {
                                        let JSONresponse = JSON.parse(response.responseText);
                                        judgemeWrapper.innerHTML = JSONresponse.badge;
                                        data.judgeme.observedIds[itemGroupId] = JSONresponse.badge;
                                    } else {
                                        console.log(`Judgeme Server Error: ${response.status}`);
                                    }                                    
                                }
                            }
                            data.judgeme.productBlockObserver.unobserve(item.target);
                        }
                    });
                },
                getProductIdsAndFetchReviews: function () {
                    try {
                        const reviewElements = document.querySelectorAll(".jdgm-widget");
                        const productIds = [];

                        reviewElements.forEach(element => {
                            const productId = element.getAttribute("data-id");
                            if (productId) {
                                productIds.push(productId);
                            }
                        });
                        _getStarsReview(productIds);
                        async function _getStarsReview(items) {
                            for (const item of items) {
                                const response = await _callJudgemeAPI(item, "https://judge.me/api/v1/widgets/preview_badge");
                                const status = response.status;
                                if (status === 0 || (status >= 200 && status < 400)) {
                                    let judgemeWrapper = document.querySelector(`.klevu-ratings-wrapper .jdgm-widget[data-id="${item}"]`);
                                    let JSONresponse = JSON.parse(response.responseText);
                                    judgemeWrapper.innerHTML = JSONresponse.badge;
                                } else {
                                    console.log(`Judgeme Server Error: ${response.status}`);
                                }
                            }
                        }
                    } catch (error) {
                        console.log('KLEVU ERROR: Judgeme API did not complete', error);
                    }
                },
                initializeSwatchesUpdate: function () {
                    const config = {
                        containers: ".klevu-superior-swatches",
                        variantSwatch: ".variant-swatch",
                        productTile: ".klevuProduct",
                        dataAttributes: {
                            variantId: "data-variant-id",
                            salePrice: "data-sale-price",
                            regularPrice: "data-regular-price",
                            image: "data-image",
                            size: "data-size",
                        },
                        updateSelectors: {
                            id: "[data-id]",
                            salePrice: ".kuPrice .kuSalePrice",
                            regularPrice: ".kuPrice .kuOrigPrice",
                            image: ".klevuImgWrap a img",
                            size: ".klevu-sizes-values",
                        },
                    };

                    const swatches = document.querySelectorAll(config.containers);
                    swatches.forEach(container => {
                        const productTile = container.closest(config.productTile);
                        if (!productTile) return; // Ensure product tile is found

                        container.addEventListener("click", event => {
                            const swatch = event.target.closest(config.variantSwatch);
                            if (!swatch) return; // Ensure swatch is found

                            updateSelectedSwatch(container, swatch);
                            updateProductTile(productTile, swatch, config);
                        });
                    });

                    function updateSelectedSwatch(container, swatch) {
                        const previouslySelected = container.querySelectorAll(`${config.variantSwatch}.selected`);
                        previouslySelected.forEach(s => s.classList.remove("selected"));
                        swatch.classList.add("selected");
                    }

                    function updateProductTile(productTile, swatch, config) {
                        let variantId;
                        Object.entries(config.dataAttributes).forEach(([key, attr]) => {
                            const value = swatch.getAttribute(attr);
                            if (!value) return; // Skip if attribute is null or undefined

                            switch (key) {
                                case "variantId":
                                    variantId = value;
                                    productTile.setAttribute("data-id", value);
                                    break;
                                case "salePrice":
                                    updatePrice(productTile, config.updateSelectors.salePrice, value);
                                    break;
                                case "regularPrice":
                                    updatePrice(productTile, config.updateSelectors.regularPrice, value);
                                    break;
                                case "image":
                                    const imageElement = productTile.querySelector(config.updateSelectors.image);
                                    if (imageElement) imageElement.src = value;
                                    break;
                            }
                        });

                        if (variantId) {
                            updateLinks(productTile, variantId);
                        }
                    }

                    function updatePrice(productTile, selector, value) {
                        const priceElement = productTile.querySelector(selector);
                        if (priceElement) priceElement.innerText = value;
                    }

                    function updateLinks(productTile, variantId) {
                        const links = productTile.querySelectorAll("a");
                        links.forEach(link => {
                            const url = new URL(link.href);
                            url.searchParams.set("variant", variantId);
                            link.href = url.toString();
                        });
                    }
                },
                renderProductVariants: function (dataLocal) {
                    if (!dataLocal || !dataLocal.additionalDataToReturn) {
                        return ""; // No data to process
                    }

                    const productVariants = JSON.parse(dataLocal.additionalDataToReturn);

                    if (productVariants.variants.length === 1 && typeof productVariants.variants[0].swatch_image === "undefined") {
                        return ""; // No data to process
                    }

                    let htmlContent = '<div class="klevu-superior-swatches">';

                    // Navigation left button
                    htmlContent += `
                        <div class="kcResultItemNavigation">
                            <button data-side="LEFT" class="kcResultItemNavigationButton kcResultItemNavigationButtonLeft">
                                <svg height="20" width="20" viewBox="0 0 100 100">
                                    <path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path>
                                </svg>
                            </button>
                        </div>`;

                    const renderedImages = new Set();

                    // Iterate over each variant
                    for (const variant of productVariants.variants) {
                        if (typeof variant.swatch_image === "undefined" || variant.stock_status === "no" || renderedImages.has(variant.image)) {
                            continue; // Skip if this image has already been rendered
                        }

                        let kuPercent;
                        if (!isNaN(variant.salePrice) && !isNaN(variant.price) && variant.price > variant.salePrice) {
                            kuPercent = 100 - Math.round((variant.salePrice / variant.price) * 100);
                        }

                        // Variant swatch div
                        htmlContent += `
                            <div class="variant-swatch" 
                                data-variant-id="${variant.variant_id}" 
                                ${kuPercent !== undefined ? `data-discount="${kuPercent}"` : ""} 
                                data-image="${variant.image}"
                                data-color="${variant.color}" 
                                data-swatch="${variant.options1_filter}"
                                data-size="${variant.size}" 
                                data-sale-price="${window.klevuCurrentScope.template
                                    .getHelpers()
                                    .processCurrency(dataLocal.currency, parseFloat(variant.salePrice))}" 
                                data-regular-price="${window.klevuCurrentScope.template
                                    .getHelpers()
                                    .processCurrency(dataLocal.currency, parseFloat(variant.price))}" 
                                data-name="${variant.name}">
                                <img src="${variant.swatch_image}" alt="Swatch Image">
                                <span style="border: 1px solid #e8e8e8; background: url(${variant.swatch_image})"></span>
                            </div>`;

                        // Mark this image as rendered
                        renderedImages.add(variant.image);
                    }

                    // Navigation right button
                    htmlContent += `
                        <div class="kcResultItemNavigation">
                            <button data-side="RIGHT" class="kcResultItemNavigationButton kcResultItemNavigationButtonRight">
                                <svg height="20" width="20" viewBox="0 0 100 100" transform="rotate(180)">
                                    <path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path>
                                </svg>
                            </button>
                        </div>
                    </div>`;

                    return htmlContent;
                },
                filterOpener: function () {
                    if (document.querySelector(".ku-filterOpener")) {
                        klevu.event.attach(document.querySelector(".ku-filterOpener"), "click", function (event) {
                            document.getElementsByTagName("body")[0].classList.toggle("kuFilters_opened");
                        });
                    }
                },
                filterCategoryOptions: function filterCategoryOptions(data) {
                    // Find the category and brand objects
                    const categoryObj = data.find(item => item.key === "category");
                    const brandObj = data.find(item => item.key === "brand");

                    if (!categoryObj || !brandObj) {
                        // console.error("Category or Brand object not found");
                        return data;
                    }

                    // Create a set of brand values for quick lookup
                    const brandValues = new Set(brandObj.options.map(option => option.value));

                    // Filter the category options - remove the options from the "category" if the option value is the same as in the "brand"
                    categoryObj.options = categoryObj.options.filter(option => !brandValues.has(option.value));

                    return data;
                },
                customClickOnProduct: function customClickOnProduct() {
                    var productList = _toConsumableArray(document.querySelectorAll('.klevuProduct'));
                
                    for (var i = 0; i < productList.length; i++) {
                      var element = productList[i];
                      element.addEventListener('click', function (e) {
                        var currentLI = e.target.closest('.klevuProduct'); 
                        if (typeof klevu_customProductClick === 'function') {
                            klevu_customProductClick(JSON.parse(decodeURIComponent(currentLI.dataset.customClick))); 
                        }
                      });
                    }
                },
                addFilterAndPaginationToURL: function () {
                    return {
                        addURLtoHistory: function (data, scope, queryId) {
                            if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                                console.error("This browser does not have the support of window.history or window.history.pushState");
                                return;
                            }
                            var searchPath = new URLSearchParams(window.location.search);
                            var currentSearchPath;
                            var previousSearchPath = searchPath.toString();
                            // this is in case we're running our code where we dont have context.activeQueryId
                            var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                            if (queryId && queryId.length) {
                                activeQueryId = queryId;
                            }
                            // Check if there any filter selected
                            let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                            let isThereFiltersSelected = false;
                            // Check if applyFilters is an object (but not an array), and not empty
                            if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                                isThereFiltersSelected = true;
                            }
                            // PAGINATION TO URL
                            var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                            var paginationQueryParam = "Page";
                            var currentPage = 0;
                            if (hasPaginationEnabled) {
                                var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                                if (activeQueryMeta) {
                                    var productListLimit = activeQueryMeta.noOfResults;
                                    currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                                }
                                if (currentPage === 0 || currentPage === 1) {
                                    searchPath.delete(paginationQueryParam);
                                } else {
                                    searchPath.set(paginationQueryParam, currentPage);
                                }
                                currentSearchPath = searchPath.toString();
                            };
                            // FILTERS TO URL
                            var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                            var filterValuesQueryParam = "";
                            if (activeQueryFilters) {
                                klevu.each(activeQueryFilters, function (key, filter) {
                                    var selectedFilterKeyString = "";
                                    var filterOptions = filter.options;
                                    var selectedValues = "";
                                    if (filterOptions && filterOptions.length) {
                                        klevu.each(filterOptions, function (key, option) {
                                            if (option.selected === true) {
                                                if (selectedValues.length) {
                                                    selectedValues += ",";
                                                }
                                                selectedValues += option.value;
                                            }
                                        });
                                    } else if (filter.type === "SLIDER") {
                                        var startValue = filter.start;
                                        var endValue = filter.end;
                                        var minValue = filter.min;
                                        var maxValue = filter.max;
                                        if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                            if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                                // just skipping
                                            } else {
                                                selectedValues = startValue + "-" + endValue;
                                            }
                                        }
                                    }
                                    if (selectedValues.length) {
                                        // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                        selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                    }
                                    if (selectedFilterKeyString.length) {
                                        if (filterValuesQueryParam.length) {
                                            filterValuesQueryParam += ";";
                                        }
                                        filterValuesQueryParam += selectedFilterKeyString;
                                    }
                                });
                            }
                            if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                                searchPath.set("Filters", filterValuesQueryParam);
                            } else {
                                searchPath.delete("Filters");
                            }
                            currentSearchPath = searchPath.toString();
                            // ==============================
                            // Final URL change
                            if (previousSearchPath !== currentSearchPath) {
                                var historyState = { page: currentPage, filters: currentSearchPath };
                                window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                            }
                        },
                        restoreSearchParamsOnPageLoad: function (data, scope) {
                            var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                            if (hasAlreadyTriggered) return;
                            // var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                            var activeQueryId = "productList";
                            var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                            var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                            var matchedQueryParamId = "";
                            var matchedQueryParamValue = "";
                            var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id) {
                                        if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                            matchedQueryParamId = recordQuery.id;
                                            matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                        }
                                    }
                                });
                            }
                            klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);
                            matchedQueryParamId = "productList";
                            if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                                activeQueryId = matchedQueryParamId;
                                var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                                if (storage.tabs) {
                                    storage.tabs.setStorage("local");
                                    storage.tabs.mergeFromGlobal();
                                    storage.tabs.addElement("active", activeQueryId);
                                    storage.tabs.mergeToGlobal();
                                }
                            }
                            if (paginationFromURL && paginationFromURL > 1) {
                                if (recordQueries && recordQueries.length) {
                                    klevu.each(recordQueries, function (key, recordQuery) {
                                        if (recordQuery.id === activeQueryId) {
                                            var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                            limit = Number(limit);
                                            if (limit > 0) {
                                                var expectedOffset = (paginationFromURL - 1) * limit;
                                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                            }
                                        }
                                    });
                                }
                            }
                            // FILTERS
                            if (filtersFromURL && filtersFromURL.length) {
                                var facets = filtersFromURL.split(";");
                                if (facets) {
                                    klevu.each(facets, function (key, facet) {
                                        var splitFacet = facet.split(":");
                                        if (splitFacet.length) {
                                            var facetKey = decodeURIComponent(splitFacet[0]);
                                            var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                            var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");
                                            if (applyFilters && applyFilters.length) { // if there're some filters
                                                var isExistingKey = false;
                                                klevu.each(applyFilters, function (key, applyFilter) {
                                                    if (applyFilter.key === facetKey) {
                                                        isExistingKey = true;
                                                        klevu.each(facetValues, function (key, facetValue) {
                                                            var isFilterOptionMatched = false;
                                                            klevu.each(applyFilter.values, function (key, value) {
                                                                if (facetValue === value) {
                                                                    isFilterOptionMatched = true;
                                                                }
                                                            });
                                                            if (!isFilterOptionMatched) {
                                                                applyFilter.values.push(facetValue);
                                                            }
                                                        });
                                                    }
                                                });
                                                if (!isExistingKey) {
                                                    applyFilters.push({ key: facetKey, values: facetValues });
                                                }
                                            } else {
                                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                            }
                                        }
                                    });
                                }
                            }
                        },
                        updatePayloadOnPopState: function (data, scope, activeQueryId) {
                            // SET PAGINATION PAYLOAD
                            const paginationFromURL = Number(klevu.dom.helpers.getQueryStringValue("Page"));
                            const currentQueryRequest = scope.kScope.data.request.original.queryRequest;
                            const activeListObject = Object.values(currentQueryRequest).find(item => item.id === activeQueryId);
                            const limit = Number(activeListObject.settings.limit);
                            if (limit > 0) {
                                var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            }
                            // SET FILTER PAYLOAD
                            var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                            if (filtersFromURL && filtersFromURL.length) {
                                var facets = filtersFromURL.split(";");
                                // loop through all facets to get its values
                                let facetKey = '';
                                let facetValues = [];
                                let facetsArray = [];
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        facetKey = decodeURIComponent(splitFacet[0]);
                                        facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        facetsArray.push({ key: facetKey, values: facetValues });
                                    }
                                });
                                // set the payload with correct filters:
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                            } else { // reset filters if Back button pressed, and there's no filters
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                            }
                        },
                        buckButtonEvent: function (event) {
                            try {
                                // passing activeQueryId because it's lost once we reset the data below
                                var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
                                // code to get ready to reset all the data
                                var data = window.klevuCurrentScope.element.kObject.getScope().data;
                                var scope = window.klevuCurrentScope.element;
                                scope.kScope.data = scope.kObject.resetData(scope.kElem);
                                scope.kScope.data.context.keyCode = 0;
                                scope.kScope.data.context.eventObject = event;
                                scope.kScope.data.context.event = "keyUp";
                                scope.kScope.data.context.preventDefault = false;
                                // Get payload for Filters & Pagination
                                scope.kScope.template.getHelpers().addFilterAndPaginationToURL().updatePayloadOnPopState(data, scope, activeQueryId);
                                // Fire request, re-render results
                                klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
                            } catch (error) {
                                console.log(error)
                            }
                        }
                    }
                }
            },
        },
    },
});

klevu.dom.helpers.addElementToHead({
    name: "klevu-custom-styles",
    content: customStyleContent,
    type: "css",
});

klevu.beforeActivation("landing,catnav", function (data, scope) {
    window.klevuCurrentScope = scope.kScope;

    document.getElementsByTagName("body")[0].classList.add("ku-klevu");

    // scope.kScope.template.getHelpers().getProductIdsAndFetchReviews();

    // Use Intersection Observer to fetch reviews when the browser supports it and the product block is at least 20% in view
    const observerOptions = {
        // We want to know when the element enters the viewport
        root: null, 
        // Trigger when 20% of the target is visible
        threshold: 0.2 
    };
    const observerCallback = function (entries, observer) {
        scope.kScope.template.getHelpers().getProductReviewCallback(data, entries);
    }
    data.judgeme = {
        observedIds: {},
        productBlockObserver: IntersectionObserver ? new IntersectionObserver(observerCallback, observerOptions): null,
    };

    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, "results", true);
    scope.kScope.template.setTemplate(klevuLandingTemplateSortByCustom, "sortBy", true);
    scope.kScope.template.setTemplate(klevuLandingTemplateBaseCustom, "klevuTemplateLanding", true);
    scope.kScope.template.setTemplate(kuFilterTagsTemplateCustom, "kuFilterTagsTemplate", true);
    scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, "productBlock", true);
    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, "filters", true);

    klevu.extend(true, klevu.search.modules, {
        locale: {
            globalTranslations: {
                de: {
                    "Narrow by": "Filtern nach",
                    "<b>%s</b> contentList": "Anderer Inhalt",
                    "Sort by : ": "Sortieren nach:",
                },
            },
        },
    });

    // Add event listener for back button
    window.onpopstate = scope.kScope.template.getHelpers().addFilterAndPaginationToURL().buckButtonEvent;

    // // create an intersection observer to check if the productBlock is at least 30px in view
    // const productBlockObserver = new IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //         if (entry.isIntersecting) {
    //             scope.kScope.template.getHelpers().getProductIdsAndFetchReviews();
    //         }
    //     });
    // });
    // scope.kScope.data.judgeme = {
    //     productBlockObserver: productBlockObserver,
    // }
});

klevu.modifyRequest("landing, catnav", function (data, scope) {
    klevu.each(data.request.current.recordQueries, function (key, query) {
        klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);
        query.settings.limit = 40;
    });

    // set the global scope
    window.klevuCurrentScope = scope.kScope;

    // Restore Search Params On Page Load
    scope.kScope.template.getHelpers().addFilterAndPaginationToURL().restoreSearchParamsOnPageLoad(data, scope);
});

klevu.modifyResponse("landing, catnav", function (data, scope) {
    const recordQueries = klevu.getObjectPath(data, "template.query.productList.filters");
    scope.kScope.template.getHelpers().filterCategoryOptions(recordQueries);
});

klevu.afterTemplateRender("landing,catnav", function (data, scope) {
    if (!scope.kScope.template.getHelpers().isScreenWidthSmaller()) {
        scope.kScope.template.getHelpers().initSwatchesCarousel(data, scope);
    }
    
    // Fetch reviews for product blocks that are in view or fetch all reviews if the observer is not supported
    if (data.judgeme.productBlockObserver) {
        const productBlocks = document.querySelectorAll(".klevuProduct[data-item-group-id]");
        klevu.each(productBlocks, function(key, item) {
            data.judgeme.productBlockObserver.observe(item);
        });
    } else {
        scope.kScope.template.getHelpers().getProductIdsAndFetchReviews();        
    }

    scope.kScope.template.getHelpers().initializeSwatchesUpdate();
    scope.kScope.template.getHelpers().filterOpener();
    scope.kScope.template.getHelpers().customClickOnProduct(data.template.query.productList.result);

    if (typeof klevu_customProductImpressions === 'function') {
        klevu_customProductImpressions(data.template.query.productList.result);
    }

    // Add selected FILTERS and PAGINATION to the URL
    scope.kScope.template.getHelpers().addFilterAndPaginationToURL().addURLtoHistory(data, scope);

});

const klevuLandingTemplateBaseCustom = `
<div ku-container data-container-id="ku_landing_main_container" data-container-role="main">

<header ku-container data-container-id="ku_landing_main_header_container" data-container-role="header">
    <section ku-block data-block-id="ku_landing_main_header_sub_panel"></section>
    <section ku-block data-block-id="ku_landing_main_header_banner">
        <%=helper.render('klevuLandingPromotionBanner',scope,data,"top") %>
        <%=helper.render('klevuLandingPromotionBanner',scope,data,"bottom") %>
    </section>
    <section ku-block data-block-id="ku_landing_main_header_site_navigation"></section>
</header>
    
<div class="kuContainer">
    <% if(!helper.hasResults(data,"productList") && !helper.hasFilters(data,"productList")) { %>                
        <%=helper.render('noResultsFoundLanding',scope) %>
    <% } else { %>
        <%= helper.render('klevuLandingTemplateSearchBar', scope) %>   
        <%=helper.render('klevuLandingImageSearchUploadBanner',scope,data) %>             
        <%= helper.render('results',scope) %>
    <% } %>
    <div class="kuClearBoth"></div>
</div>

<footer ku-container data-container-id="ku_landing_main_footer_container" data-container-role="footer">
    <section ku-block data-block-id="ku_landing_main_footer_sub_panel"></section>
    <section ku-block data-block-id="ku_landing_main_footer_banner">                

    </section>
</footer>

</div>
`;
const klevuLandingTemplateFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="ku-mobFilterWrapper">
    <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <h3 class="kuFiltersTitleHeading"><%=helper.translate("FILTERN NACH")%></h3>
        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
            <% if (helper.isScreenWidthSmaller()) { %>
                <% filter.isCollapsed = true;%>

            <% } %>
            <% if(filter.type == "OPTIONS"){ %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 && !helper.isScreenWidthSmaller()) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text"><%=filterOption.name%></span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 5 ) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                          <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                              <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                          </div>
                    </div>
                </div>
            <% } else if (filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>
        
        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
          </div> -->
        
    </div>
    </div>
<% } %>
`;
const klevuLandingTemplateProductBlockCustom = `<% 
    var updatedProductName = dataLocal.name;
    dataLocal.hasBrand = typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '';

    // Check if the SKU should be included and clean it up
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }

    // Check if title_additive exists and append it with a comma
    if (typeof dataLocal.title_additive !== 'undefined' && dataLocal.title_additive !== '') {
        updatedProductName += ', ' + dataLocal.title_additive;
    }
        
    var startPrice = dataLocal.startPrice;
    if (typeof dataLocal.additionalDataToReturn !== 'undefined' && dataLocal.additionalDataToReturn !== '') {
        var productVariants = JSON.parse(dataLocal.additionalDataToReturn);
        var stockYesVariants = productVariants.variants.filter(function(variant) {
            return variant.stock_status === "yes";
        });

        if (stockYesVariants.length > 0) {
            startPrice = Math.min.apply(null, stockYesVariants.map(function(variant) {
                return parseFloat(variant.price);
            }));
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>" <% if (dataLocal.hasBrand) { %>data-item-group-id="<%=dataLocal.itemGroupId%>"<% } %> data-custom-click="<%=encodeURIComponent(JSON.stringify(dataLocal))%>" >
    <% if (!helper.isScreenWidthSmaller()) { %>
        <%= helper.renderProductVariants(dataLocal) %>
    <% } %>
    <div class="kuProdWrap">

        <header ku-block data-block-id="ku_landing_result_item_header">
            <div class="swym-wishlist-collections-v2-container">
                <div class="swym-wishlist-collections-v2" data-product-id="<%=dataLocal.url%>" >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns=http://www.w3.org/2000/svg>
                        <g clip-path="url(#clip0_620_405)">
                        <path class="swym-wishlist-collections-icon-heart-unfilled" d="M12 21C11.8684 21.0008 11.7379 20.9755 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.52 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23C1.99866 7.84443 2.54536 6.51482 3.52 5.53C4.50226 4.55051 5.83283 4.00047 7.22 4.00047C8.60717 4.00047 9.93774 4.55051 10.92 5.53L12 6.61L13.08 5.53C14.0623 4.55051 15.3928 4.00047 16.78 4.00047C18.1672 4.00047 19.4977 4.55051 20.48 5.53C21.4546 6.51482 22.0013 7.84443 22.0013 9.23C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9755 12.1316 21.0008 12 21ZM7.22 6C6.79668 5.99808 6.37718 6.08018 5.98581 6.24154C5.59444 6.40289 5.23897 6.6403 4.94 6.94C4.33606 7.54712 3.99704 8.36865 3.99704 9.225C3.99704 10.0814 4.33606 10.9029 4.94 11.51L12 18.58L19.06 11.51C19.6639 10.9029 20.003 10.0814 20.003 9.225C20.003 8.36865 19.6639 7.54712 19.06 6.94C18.4437 6.35771 17.6279 6.0333 16.78 6.0333C15.9321 6.0333 15.1163 6.35771 14.5 6.94L12.71 8.74C12.617 8.83373 12.5064 8.90812 12.3846 8.95889C12.2627 9.00966 12.132 9.0358 12 9.0358C11.868 9.0358 11.7373 9.00966 11.6154 8.95889C11.4936 8.90812 11.383 8.83373 11.29 8.74L9.5 6.94C9.20103 6.6403 8.84556 6.40289 8.45419 6.24154C8.06282 6.08018 7.64332 5.99808 7.22 6Z"></path>
                        </g>
                        <defs><clipPath id="clip0_620_405"><rect width="24" height="24" fill="white"></rect></clipPath></defs>
                    </svg>
                </div>
            </div>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
            
                <div class="klevuImgWrap">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a>                        
                </div>
                <!-- <div class="kuQuickView">
                    <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button>
                </div> -->
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">   
                <% if (dataLocal.hasBrand) { %>
                <div class="klevu-brand-header">
                    <div class="klevu-brand"><%= dataLocal.brand%></div>  
                        <div class="klevu-ratings-wrapper">
                        <div class="klevu-ratings">
                            <div 
                                class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" 
                                data-id="<%=dataLocal.itemGroupId%>" 
                                data-template="manual-installation" 
                                data-auto-install="false"
                                data-handle="<%= dataLocal.url.split('/').pop() %>"
                                >
                            </div>
                        </div>      
                    </div>   
                </div>
                <% } %> 
                <div class="kuName kuClippedOne">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>">
                        <%= updatedProductName %>
                    </a>
                </div>

                <% if (helper.isScreenWidthSmaller()) { %>
                    <%= helper.renderProductVariants(dataLocal) %>
                <% } %>

                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("ab")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>

                            <span class="kuSalePrice kuSpecialPrice kuClippedOne red">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="kuSalePrice kuSpecialPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="kuSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                        
                        <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>

                        <%  const salePrice = Number(dataLocal.salePrice);
                            const price = Number(dataLocal.price); %>
                            <% if (!Number.isNaN(salePrice) && !Number.isNaN(price) && (price > salePrice)) { %>
                                <% const kuPercent = 100 - Math.round((salePrice / price) * 100);%>
                                <% if (kuPercent > 0) { %>
                                    <div class="klevu-badge">-<%= kuPercent %>%</div>
                                <% } %>
                        <% } %>

                    </div>
                <% } %>
                <% } %>
                <% if (typeof dataLocal.additionalDataToReturn !== 'undefined' && dataLocal.additionalDataToReturn !== '') { %>
                    <% var productVariants = JSON.parse(dataLocal.additionalDataToReturn); %>
                    <% const uniqueSizes = Array.from(new Set(productVariants.variants
                        .map(item => item.size)
                    )); %>
                    <% if (uniqueSizes.length !== 1 || uniqueSizes[0] !== '') { %>
                        <div class="klevu-sizes"> <span> Varianten: </span>
                            <span class="klevu-sizes-values">
                                <% let sizesString = ""; %>
                                <% uniqueSizes.forEach((size, index) => { %>
                                    <% sizesString += size; %>
                                    <% if (index < uniqueSizes.length - 1) { %>
                                        <% sizesString += " · "; %>
                                    <% } %>
                                <% }) %>
                                <%= sizesString %>
                            </span>
                        </div>
                    <% } %>
                <% } %>
            </div>

            <!-- bocChangeGrundPrice -->
            <% if(dataLocal.v_grundpreis && dataLocal.v_grundpreis !== '' && dataLocal.v_grundpreis !== '0.00' && dataLocal.v_grundpreis !== 0) { %>
                <!-- < % console.log('Klevu dataLocal', dataLocal) % > -->
                <div class="bocChangeGrundPrice">
                    <span class="text-sm text-subdued">Grundpreis: <%=dataLocal.v_grundpreis%> / <%=dataLocal.grundpreis_text%></span>
                </div>
            <% } %>

            <div class="kuProdAdditional">
                <div class="kuProdAdditionalData">
                    <% if(desc && desc.length) { %>
                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                    <% } %>
                    <%=helper.render('landingProductSwatch',scope,data,dataLocal) %>
                    <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>
                    <% var isAddToCartEnabled = klevu.search.modules.kmcInputs.base.getAddToCartEnableValue(); %>
                    <% if(isAddToCartEnabled) { %>
                        <%=helper.render('landingPageProductAddToCart',scope,data,dataLocal) %> 
                    <% } %>
                </div>
            </div>
         </footer>             
    </div>
</li>
`;

const klevuLandingTemplateResultsCustom = `

<%
    var searchedTerm = helper.escapeHTML(data.settings.term);
    var isCATNAV = data.settings.isCATNAV;
%>
<%if (!isCATNAV) { %>
<h1 class="klevu-searchresults-title">Suche nach "<%= klevu.dom.helpers.cleanCatogeryPath(searchedTerm)%>"</h1>
<%}%>

<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">  
                            <% if(helper.isScreenWidthSmaller()){ %>
                                    <div class="ku-filterOpener">
                                        <span> Filtern nach </span>
                                    </div>
                            <% } %>                                
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                            <%= helper.render('tab-results', scope) %>                

                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                                <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                <%=helper.render('productBlock',scope,data,item) %>
                                            <% } %>
                                        <% }); %>
                                    </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                            <%=helper.render('pagination',scope,data,"productList") %>

                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>
                
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <%= helper.render('tab-results', scope) %>                

                                <% if(helper.hasResults(data,"contentList")) { %>
                                    <%=helper.render('limit',scope,data,"contentList") %>
                                    <%=helper.render('pagination',scope,data,"contentList") %>
                                <% } %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    <% } %> 

</div>
`;

const klevuLandingTemplateSortByCustom = `
<div class="kuDropdown kuDropSortBy" role="listbox">
    <%=helper.translate("Sort by : ")%>
    <div class="kuDropdownLabel">
        <%=helper.myCustomSortBy(dataLocal)%>
    </div>
    <div class="kuDropdownOptions">
        <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option">Relevanz</div> <!-- <%=helper.translate("Relevance")%> --->
        <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option">Preis niedrig bis hoch</div> <!-- <%=helper.translate("Price: Low to high")%> --->
        <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option">Preis: hoch bis niedrig</div> <!-- <%=helper.translate("Price: High to low")%> --->
        <div class="kuDropOption kuSort" data-value="NAME_ASC" role="option">Name: A zu Z</div> <!-- <%=helper.translate("Name: A to Z")%> --->
        <div class="kuDropOption kuSort" data-value="NAME_DESC" role="option">Name: Z zu A</div> <!-- <%=helper.translate("Name: Z to A")%> --->
        <div class="kuDropOption kuSort" data-value="NEW_ARRIVAL_DESC" role="option">Neueste zu Älteste</div> <!-- <%=helper.translate("Newest to Oldest")%> --->
        <div class="kuDropOption kuSort" data-value="NEW_ARRIVAL_ASC" role="option">Älteste zu Neueste</div> <!-- <%=helper.translate("Oldest to Newest")%> --->
    </div>
</div>
`;
const klevuQuickProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
                <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
            </div>
        </div>
        <div class="klevuProductItemBottom">
            <div class="klevuQuickProductDescBlock">
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>
`;
const klevuQuickTemplateBaseCustom = `
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
            
            <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                <% if(quickFacetedLayoutMessage != "") { %>
                    <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                <% } %>                    
            <% } else { %>
                <% if(data.query.productList) { %>
                    <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                    <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                    <%= helper.render('klevuQuickProducts',scope) %>
                    <%= helper.render('klevuQuickOtherContent',scope) %>
                <% } else { %>              
                    <div class="kuSearchPersonalizationsContainer">
                        <%= helper.render('klevuSearchPersonalizations',scope) %>    
                    </div>
                <% } %>  
            <% } %>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
        </div>
    </div>
</div>
`;
const kuFilterTagsTemplateCustom = `
<% 
        var filterTagsModule = data.filterTags;
        var filterTagsData = [];
        if(dataLocal && dataLocal.length){
            filterTagsData = filterTagsModule.query[dataLocal].tags;
        }
    %>
    <% if(filterTagsData.length) { %>
        <div class="kuFilterTagsContainer">        
            <% helper.each(filterTagsData, function(key,item){ 
                var filterTagItemKey = helper.escapeHTML(item.key);
                var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
                %>
                <span 
                    class="kuFilterTag" 
                    data-key="<%= filterTagItemKey %>"
                    data-type="<%= helper.escapeHTML(item.type) %>"
                >
                    <% helper.each(item.values, function(key,option){ %>
                        <% if(item.type === "RATING") { %>
                            <span 
                                title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                class="kuFilterTagValue">
                                <div class="klevuFacetStars">
                                    <div class="klevuFacetRating" style="width:<%=(20*Number(option))%>%;"></div>
                                </div>
                                <span>&times;</span>
                            </span>
                        <% } else { %>
                            <span 
                                title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                class="kuFilterTagValue">
                                <%= helper.translate(item.label) %> : <%= helper.translate(option) %>
                                <span>&times;</span>
                            </span>
                        <% } %>
                    <% }); %>
                </span>
            <% }); %>
            <span title="<%= helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span>
        </div>
    <% } %>
`;